var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"as-employee-new-page"},[_c('AsEmployeePage',{attrs:{"tableHeaders":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }